/** В ленте достаточно минут; подробности доставки и прочтения показывают секунды. */
export function formatMessageTime(iso: string, locale?: string): string {
  return new Date(iso).toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
}

export function formatReceiptTime(iso?: string | null, locale?: string): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString(locale, {
    day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit',
  });
}
